import { render, staticRenderFns } from "./LoginFormVHUB.vue?vue&type=template&id=21362fa4&lang=html&"
import script from "./LoginFormVHUB.vue?vue&type=script&lang=js&"
export * from "./LoginFormVHUB.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormVHUB.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports